function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1905 16c-66 13-130 37-182 37-18 0-128-52-217-52-186 0-223 50-325 49-51-15-94-49-191-49-124 0-174 52-291 52S573 7 480 7 292 53 218 53 42 1 1 1H0v243h1905V16z",
  fill: "#3CA7AA"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M43 14a131 131 0 0051 12C70 18 48 10 29 6l14 8zM432 10a521 521 0 0185 4l14 3 13 4 52 19c18 6 37 10 57 10-75-10-94-44-173-44l-48 4zM903 10a631 631 0 0183-5l16 1h8l8 1 8 1h8l8 1 8 2 16 3a484 484 0 0161 18l15 5 8 2 8 3c-42-17-85-41-168-41-33 0-61 4-87 9zM1510 6h8l8 1h9l33 5c23 3 45 8 67 13-40-12-87-24-129-24-61 0-106 5-142 12a1282 1282 0 01137-7h9z",
  fill: "#62BCB3"
});

var SvgSeaWave3 = function SvgSeaWave3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 1905,
    height: 244,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSeaWave3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sea-wave-3.1c1c1192.svg";
export { ForwardRef as ReactComponent };